// import React from "react";
// import { useSelector } from "react-redux";
// import { Store } from "interfaces";

export default ({ resource }: { resource: any }) => {
	return null;
	// const errors = useSelector((store: tcpinpoint.Store) => store.errors);
	// return <div>{JSON.stringify(errors[resource.id])}</div>;
};
